import { Alert, Button, Card, Col, Divider, Space, Tag, Typography } from 'antd';

const BillingSubscriptionSection = ({
  currentStatus,
  activePlan,
  subscription,
  formatDateTime,
  quotaRows,
  creditSummary,
  toNonNegativeInt,
  onBuyCredits,
  onRefreshSubscription,
  onOpenHistory,
}) => (
  <Col xs={24} xl={10}>
    <Card className="billing-card" title="当前订阅">
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        {currentStatus === 'active' ? (
          <>
            <div className="billing-title">
              <Typography.Title level={4} style={{ margin: 0 }}>
                {activePlan?.name || '订阅已生效'}
              </Typography.Title>
              <Tag color="green">有效</Tag>
            </div>
            <div className="billing-meta">
              到期时间：
              <span className="billing-meta__value">{formatDateTime(subscription?.active?.current_period_end)}</span>
            </div>
          </>
        ) : (
          <>
            <div className="billing-title">
              <Typography.Title level={4} style={{ margin: 0 }}>
                暂未开通
              </Typography.Title>
              <Tag color={currentStatus === 'expired' ? 'orange' : 'default'}>
                {currentStatus === 'expired' ? '已到期' : '未订阅'}
              </Tag>
            </div>
            <div className="billing-meta">
              最近订阅：
              <span className="billing-meta__value">{formatDateTime(subscription?.latest?.current_period_end)}</span>
            </div>
          </>
        )}
        <Divider style={{ margin: '8px 0' }} />
        <Alert
          type="info"
          showIcon
          message="手动续费"
          description="支持手动购买，到期前后均可再次购买，新的有效期会自动叠加。"
        />
        {quotaRows.length > 0 ? (
          <Space direction="vertical" size={4} style={{ width: '100%' }}>
            <Typography.Text strong>当前配额使用</Typography.Text>
            {quotaRows.map((row) => (
              <Typography.Text key={row.key} type="secondary">
                {row.label}：
                {row.usedText
                  ? `${row.usedText} / ${row.limitText}（剩余 ${row.remainText}）`
                  : `${row.used} / ${row.limit}（剩余 ${row.remain ?? '-'}）`}
              </Typography.Text>
            ))}
          </Space>
        ) : null}
        {creditSummary ? (
          <Space direction="vertical" size={4} style={{ width: '100%' }}>
            <Typography.Text strong>当前创作积分</Typography.Text>
            <Typography.Text type="secondary">
              赠送积分：{toNonNegativeInt(creditSummary.gift_balance)}
            </Typography.Text>
            <Typography.Text type="secondary">
              购买积分：{toNonNegativeInt(creditSummary.paid_balance)}
            </Typography.Text>
            <Typography.Text type="secondary">
              当前可用：{toNonNegativeInt(creditSummary.total_spendable_balance)}
            </Typography.Text>
            {creditSummary.frozen_paid_balance ? (
              <Typography.Text type="secondary">
                已冻结购买积分：{toNonNegativeInt(creditSummary.frozen_paid_balance)}
              </Typography.Text>
            ) : null}
            {creditSummary.gift_expires_at ? (
              <Typography.Text type="secondary">
                当前赠送积分到期：{formatDateTime(creditSummary.gift_expires_at)}
              </Typography.Text>
            ) : null}
            <Button type="primary" className="billing-credit-cta-btn" onClick={onBuyCredits}>
              立即购买积分
            </Button>
          </Space>
        ) : null}
        <div>
          <Space size={12} wrap>
            <Button onClick={onRefreshSubscription} type="link" style={{ paddingLeft: 0 }}>
              刷新订阅状态
            </Button>
            <Button onClick={onOpenHistory} type="link" style={{ paddingLeft: 0 }}>
              历史订阅记录
            </Button>
          </Space>
        </div>
      </Space>
    </Card>
  </Col>
);

export default BillingSubscriptionSection;
